module.exports = __webpack_public_path__ + "files/57887897f74b4848bdbf9ef727dc5c96.png";